import React, { useState, useEffect, useMemo } from 'react';
import { Container, Button } from 'react-bootstrap';
import './../styles/dashboard.css';
import { Helmet } from 'react-helmet';
import '../styles/home.css';
import piechart from '../images/piechart.png';
import { Link } from 'react-router-dom';
import PixelsTable from '../components/tables/PixelsTable';
import DateRangeForm from '../components/forms/DateRangeForm';

export default function PixelLog() {
    const [startDate, setStartDate] = useState(PixelsTable.defaultProps.startDate);
    const [endDate, setEndDate] = useState(PixelsTable.defaultProps.endDate);
    const [loadingData, setLoadingData] = useState(true);
    // Handle changes to the date range and update state accordingly
  
    const handleFormSubmit = (startDate, endDate) => {
        // Step 4: Update the state with selected dates
        setStartDate(startDate);
        setEndDate(endDate);
        setLoadingData(true);
    };
    
    return (
        <Container className="dashboard">
            <h1>Pixel Log</h1>
            <div>
                <DateRangeForm onSubmit={handleFormSubmit}/>
                <PixelsTable startDate={startDate} endDate={endDate} loadingData={loadingData} setLoadingData={setLoadingData}   />
            </div>
        </Container>
    );
}

